/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvZWotc2hhcmVkL2NvbXBvbmVudHMvdGVuYW50LW5vdC1mb3VuZC90ZW5hbnQtbm90LWZvdW5kLmNvbXBvbmVudC5jc3MifQ== */"];
export { styles as styles };
